// Regime de consolidacao do grupo de devedoras (clients.consolidation_type).
// Sem valor = devedora unica. Mesmos codigos do ConsolidationTypeEnum da API.
export const CONSOLIDATION_PROCEDURAL = 1;
export const CONSOLIDATION_SUBSTANTIAL = 2;

export default [
    { id: null, name: "Não se aplica (devedora única)", hint: "O caso tem uma só devedora ou as empresas do grupo não foram consolidadas." },
    { id: CONSOLIDATION_PROCEDURAL, name: "Consolidação processual (art. 69-G)", hint: "Um só processo, mas cada empresa mantém o seu QGC e as deliberações são por devedora." },
    { id: CONSOLIDATION_SUBSTANTIAL, name: "Consolidação substancial (art. 69-J)", hint: "Ativos e passivos reunidos: QGC único do grupo e deliberação conjunta." },
];

export function consolidationTypeText(value) {
    const number = Number(value);
    if (number === CONSOLIDATION_PROCEDURAL) return "Consolidação processual";
    if (number === CONSOLIDATION_SUBSTANTIAL) return "Consolidação substancial";
    return null;
}
